export default "__VITE_ASSET__4b531c3e__"